import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';

export default function TermsOfService() {
  return (
    <>
      <style>{`
        html, body {
          overflow-x: hidden !important;
        }
        .terms-container {
          max-width: 800px;
          margin: 0 auto;
          padding: 40px 20px;
          line-height: 1.6;
          color: #334155;
        }
        .terms-header {
          text-align: center;
          margin-bottom: 40px;
          padding-bottom: 20px;
          border-bottom: 2px solid #e5e7eb;
        }
        .terms-header h1 {
          color: #2563eb;
          font-size: 2.5rem;
          font-weight: 900;
          margin-bottom: 10px;
        }
        .terms-header p {
          color: #64748b;
          font-size: 1.1rem;
        }
        .terms-section {
          margin-bottom: 30px;
        }
        .terms-section h2 {
          color: #2563eb;
          font-size: 1.5rem;
          font-weight: 700;
          margin-bottom: 15px;
          border-left: 4px solid #2563eb;
          padding-left: 15px;
        }
        .terms-section h3 {
          color: #475569;
          font-size: 1.2rem;
          font-weight: 600;
          margin: 20px 0 10px 0;
        }
        .terms-section p {
          margin-bottom: 15px;
          text-align: justify;
        }
        .terms-section ul {
          margin: 15px 0;
          padding-left: 20px;
        }
        .terms-section li {
          margin-bottom: 8px;
        }
        .contact-info {
          background: #f8fafc;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          padding: 20px;
          margin: 20px 0;
        }
        .back-button {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: #2563eb;
          color: white;
          padding: 12px 24px;
          border-radius: 8px;
          text-decoration: none;
          font-weight: 600;
          margin-bottom: 30px;
          transition: background-color 0.2s;
        }
        .back-button:hover {
          background: #1d4ed8;
        }
        @media (max-width: 768px) {
          .terms-container {
            padding: 20px 15px;
          }
          .terms-header h1 {
            font-size: 2rem;
          }
          .terms-section h2 {
            font-size: 1.3rem;
          }
        }
      `}</style>
      
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(90deg, #f1f5fe 0%, #fff 100%)',
        padding: '20px 0'
      }}>
        <div className="terms-container">
          <a href="/" className="back-button">
            <i className="fas fa-arrow-left"></i>
            Nazad na početnu
          </a>
          
          <div className="terms-header">
            <h1>Uslovi Korišćenja</h1>
            <p>CSV/Excel Konverter Pro</p>
            <p>Poslednje ažuriranje: {new Date().toLocaleDateString('sr-RS')}</p>
          </div>

          <div className="terms-section">
            <h2>1. Prihvatanje Uslova</h2>
            <p>
              Dobrodošli na CSV/Excel Konverter Pro ("usluga", "servis", "mi", "nas"). Pristupanjem i korišćenjem 
              naše usluge, prihvatate i pristajete da budete vezani ovim Uslovima korišćenja. Ako se ne slažete 
              sa bilo kojim delom ovih uslova, ne smete koristiti našu uslugu.
            </p>
          </div>

          <div className="terms-section">
            <h2>2. Opis Usluge</h2>
            <p>
              CSV/Excel Konverter Pro je usluga koja omogućava korisnicima da konvertuju CSV i Excel fajlove 
              u formate kompatibilne sa različitim knjigovodstvenim i ERP sistemima, uključujući TAURYSS. 
              Usluga uključuje konverziju valuta, prevod kolona i mapiranje polja.
            </p>
          </div>

          <div className="terms-section">
            <h2>3. Registracija i Nalog</h2>
            <h3>3.1 Zahtevi za Registraciju</h3>
            <p>
              Da biste koristili našu uslugu, morate:
            </p>
            <ul>
              <li>Imati najmanje 18 godina ili imati pristanak roditelja/staratelja</li>
              <li>Pružiti tačne, aktuelne i potpune informacije tokom registracije</li>
              <li>Održavati i ažurirati svoje podatke da budu tačni</li>
              <li>Održavati sigurnost svog naloga i lozinke</li>
              <li>Biti odgovorni za sve aktivnosti koje se dešavaju pod vašim nalogom</li>
            </ul>

            <h3>3.2 Zabrana Deljenja Naloga</h3>
            <p>
              Vaš nalog je ličan i ne sme biti deljen sa drugim osobama. Vi ste odgovorni za sve aktivnosti 
              koje se dešavaju pod vašim nalogom.
            </p>
          </div>

          <div className="terms-section">
            <h2>4. Plaćanje i Pretplate</h2>
            <h3>4.1 Cene</h3>
            <p>
              Cene naših usluga su navedene na našem sajtu i mogu se promeniti u bilo kom trenutku. Sve cene 
              su izražene u dinarskoj valuti (RSD) i uključuju PDV gde je to primenljivo.
            </p>

            <h3>4.2 Načini Plaćanja</h3>
            <p>
              Prihvatamo različite načine plaćanja kroz naše procesore plaćanja. Plaćanjem pristajete na 
              naše uslove i potvrđujete da imate pravo da koristite odabrani način plaćanja.
            </p>

            <h3>4.3 Automatska Obnova</h3>
            <p>
              Ako ste se pretplatili na našu uslugu, vaša pretplata će se automatski obnavljati na kraju 
              svakog fakturnog perioda osim ako je ne otkažete pre isteka tekućeg perioda.
            </p>

            <h3>4.4 Povraćaj Sredstava</h3>
            <p>
              Povraćaj sredstava je regulisan našom <a href="/refund" style={{color: '#2563eb'}}>Politikom povraćaja</a>. 
              Molimo vas da je pažljivo pročitate.
            </p>
          </div>

          <div className="terms-section">
            <h2>5. Korišćenje Usluge</h2>
            <h3>5.1 Dozvoljena Upotreba</h3>
            <p>Možete koristiti našu uslugu samo u zakonitim svrhama i u skladu sa ovim Uslovima korišćenja.</p>

            <h3>5.2 Zabranjena Upotreba</h3>
            <p>Zabranjeno vam je:</p>
            <ul>
              <li>Koristiti uslugu na bilo koji način koji krši bilo koji primenljivi zakon ili propis</li>
              <li>Otpremati, prenositi ili deliti sadržaj koji je ilegalan, štetan, uznemiravajući, uvredljiv ili na drugi način neprikladan</li>
              <li>Pokušavati da pristupite delovima usluge na koje nemate dozvolu</li>
              <li>Koristiti uslugu za prenos virusa, malvera ili drugog štetnog koda</li>
              <li>Pokušavati da zaobidete ili onesposobite sigurnosne mere usluge</li>
              <li>Koristiti automatizovane sisteme za pristup usluzi bez naše izričite dozvole</li>
              <li>Koristiti uslugu na način koji može oštetiti, onesposobiti ili preopteretiti naše servere</li>
            </ul>
          </div>

          <div className="terms-section">
            <h2>6. Intelektualna Svojina</h2>
            <p>
              Svi sadržaji, funkcionalnosti i funkcionalnosti usluge, uključujući ali ne ograničavajući se na 
              tekst, grafiku, logotipe, ikone, slike, audio klipove, digitalne preuzimanja i softver, su 
              vlasništvo CSV/Excel Konverter Pro ili naših dobavljača i zaštićeni su zakonima o autorskim 
              pravima, zaštitnim znakovima i drugim zakonima o intelektualnoj svojini.
            </p>
            <p>
              Ne smete reprodukovati, distribuirati, modifikovati, kreirati izvedena dela, javno prikazivati, 
              javno izvoditi, ponovo objavljivati, preuzimati, čuvati ili prenositi bilo koji materijal sa 
              naše usluge bez našeg prethodnog pisanog pristanka.
            </p>
          </div>

          <div className="terms-section">
            <h2>7. Podaci Korisnika</h2>
            <h3>7.1 Vlasništvo Podataka</h3>
            <p>
              Vi zadržavate sva prava na podatke koje otpremate kroz našu uslugu. Otpremanjem podataka, 
              dajete nam dozvolu da ih koristimo isključivo u svrhu pružanja usluge konverzije.
            </p>

            <h3>7.2 Čuvanje i Brisanje Podataka</h3>
            <p>
              Otpremljeni fajlovi se automatski brišu nakon završetka konverzije ili nakon 24 sata. 
              Ne čuvamo vaše fajlove duže nego što je potrebno za pružanje usluge.
            </p>
          </div>

          <div className="terms-section">
            <h2>8. Odricanje od Odgovornosti</h2>
            <p>
              Usluga se pruža "kakva jeste" i "kako je dostupna". Ne garantujemo da će usluga biti 
              neprekidna, bez grešaka ili sigurna. Ne snosimo odgovornost za bilo kakve greške, 
              propuste ili prekide u usluzi.
            </p>
            <p>
              Ne garantujemo tačnost rezultata konverzije i ne snosimo odgovornost za bilo kakve 
              posledice koje proističu iz korišćenja konvertovanih fajlova.
            </p>
          </div>

          <div className="terms-section">
            <h2>9. Ograničenje Odgovornosti</h2>
            <p>
              U najvećoj meri dozvoljenoj zakonom, CSV/Excel Konverter Pro neće biti odgovoran za 
              bilo kakve indirektne, slučajne, posebne, posledične ili kaznene štete, uključujući 
              gubitak dobiti, podataka, korišćenja, dobrog glasa ili drugih nematerijalnih gubitaka, 
              koje proističu iz ili su povezane sa vašim korišćenjem ili nemogućnošću korišćenja usluge.
            </p>
          </div>

          <div className="terms-section">
            <h2>10. Otkazivanje</h2>
            <h3>10.1 Otkazivanje od Strane Korisnika</h3>
            <p>
              Možete otkazati svoju pretplatu u bilo kom trenutku kroz vaš nalog ili kontaktiranjem 
              naše korisničke podrške. Otkazivanje će stupiti na snagu na kraju tekućeg fakturnog perioda.
            </p>

            <h3>10.2 Otkazivanje od Strane Nas</h3>
            <p>
              Zadržavamo pravo da suspendujemo ili ukinemo vaš nalog i pristup usluzi odmah, bez 
              prethodne obaveštenja, iz bilo kog razloga, uključujući ali ne ograničavajući se na 
              kršenje ovih Uslova korišćenja.
            </p>
          </div>

          <div className="terms-section">
            <h2>11. Promene Uslova</h2>
            <p>
              Zadržavamo pravo da u bilo kom trenutku izmenimo ili zamenimo ove Uslove korišćenja. 
              O svim značajnim promenama obavestićemo vas putem email-a ili kroz našu aplikaciju. 
              Vaše nastavak korišćenja usluge nakon promena predstavlja prihvatanje novih uslova.
            </p>
          </div>

          <div className="terms-section">
            <h2>12. Rešavanje Sporova</h2>
            <p>
              Ovi Uslovi korišćenja se tumače i primenjuju u skladu sa zakonima Republike Srbije. 
              Svi sporovi koji proističu iz ili su povezani sa ovim Uslovima korišćenja će se rešavati 
              pred nadležnim sudovima u Republici Srbiji.
            </p>
          </div>

          <div className="terms-section">
            <h2>13. Kontakt</h2>
            <div className="contact-info">
              <p><strong>Za sva pitanja o ovim Uslovima korišćenja:</strong></p>
              <p>Email: <a href="mailto:nemanja@lizzardsolutions.com" style={{color: '#2563eb'}}>nemanja@lizzardsolutions.com</a></p>
            </div>
          </div>

          <div style={{
            marginTop: 40,
            padding: 20,
            background: '#f8fafc',
            border: '1px solid #e5e7eb',
            borderRadius: 8,
            textAlign: 'center',
            color: '#64748b'
          }}>
            <p>&copy; {new Date().getFullYear()} CSV/Excel Konverter Pro. Sva prava zadržana.</p>
          </div>
        </div>
      </div>
    </>
  );
}

